/**
 * Client for MDR Input (backend: api/empi_input/).
 * SUPERUSER ONLY. Edits the live EMPI_INPUT.PATIENT_ALL view.
 *
 * Blocks are split out of the live view's GET_DDL on every read, so this tool
 * can never disagree with production. A save reassembles ALL blocks and issues
 * one CREATE OR REPLACE VIEW, then re-grants (the replace wipes grants).
 */
import axios from 'axios';

const BASE = '/api/empi_input';

/** { view, header, blocks: [{ ordinal, source, body, lines, chars }] } */
export async function getBlocks() {
  const { data } = await axios.get(`${BASE}/blocks/`);
  return data;
}

/** Compile one block + assert the 39-column contract. No write. */
export async function testSyntax(body) {
  const { data } = await axios.post(`${BASE}/blocks/test/`, { body });
  return data;
}

/** Replace one block and redeploy the view. */
export async function saveBlock(ordinal, body) {
  const { data } = await axios.post(`${BASE}/blocks/${ordinal}/save/`, { body });
  return data;
}

/** Reflow to one column per line. Text-only — cannot change what the SQL means. */
export async function formatBlock(body) {
  const { data } = await axios.post(`${BASE}/blocks/format/`, { body });
  return data;
}
